module.exports = __webpack_public_path__ + "static/transports-in-japan-jrpass-map-fd225d56549f37e8fd242174990a13b0.jpg";